import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import { authReducer } from "./Auth";
import { generalReducer } from "./General";
import { programsReducer } from "./Programs";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["general"],
  whitelist: ["auth", "programs"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  general: generalReducer,
  programs: programsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: true,

  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });
  },
});

const persistor = persistStore(store);

export { store, persistor };
